import {Button, Panel} from "omoplay";
import {getCreditHistory} from "../api/billing/billing.api";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import { ReactComponent as ArrowLeft } from "../assets/images/arrrow-left.svg";


const CreditDetail = () => {
    const [query] = useSearchParams()
    const id = query.get("id")

    const [historyItems, setHistoryItems] = useState([])

    useEffect(() => {
        getCreditHistory(id).then(({data}) => {
            setHistoryItems([
                {
                    title: "일시", value: data.createdAt,
                    titleStyle: {minWidth: "150px"}
                },
                {
                    title: "승인 코드", value: data.tid,
                    titleStyle: {minWidth: "150px"}
                },
                {
                    title: "카드", value: data.cardNumber,
                    titleStyle: {minWidth: "150px"}
                },
                {
                    title: "내역", value: `${data.credit.toLocaleString()} ${data.creditType === "AI" ? "Credit" : "예치금"}`,
                    titleStyle: {minWidth: "150px"}
                },
                {
                    title: "금액", value: `${data.amount.toLocaleString()}원`,
                    titleStyle: {minWidth: "150px"}
                },
                {
                    title: "유형", value: data.type,
                    titleStyle: {minWidth: "150px"}
                }
            ])
        })
    }, [])

    return (
        <div className="flex-col gap-4 ">
            <div className="flex-align-center gap-4" style={{borderRadius: "6px"}}>
                <Button variants="outlined"
                        style={{width: "40px"}}
                        onClick={() => window.location.href = ("/credit")}
                        value={<ArrowLeft />}
                />
                <div className="font-20px">내역 상세 정보</div>
            </div>
            <div className="bg-white">
                <Panel variants="list-bar" items={historyItems} />
            </div>
        </div>
    )
}

export default CreditDetail